import {Injectable} from '@angular/core';
import {WebSocketService} from '@app/modules/shared/services/web-socket.service';
import {ClassroomMessage, DataService} from '@app/services/data.service';
import {ClassroomState, ClassroomStateModel} from '@app/state/classroom-state.service';
import {Store} from '@ngxs/store';
import {LocalUser, LocalUserState} from '@app/state/local-user.state';
import {AccessType} from '@app/modules/shared/data/constants';
import {CoreService} from '@app/services/core.service';

@Injectable({
  providedIn: 'root'
})
export class MessageHandleService {
  private localUser: LocalUser;
  private classroom: ClassroomStateModel;

  constructor(
    private webSocketService: WebSocketService,
    private dataService: DataService,
    private coreService: CoreService,
    private store: Store
  ) {
    this.listenStoreChanges();
  }

  private listenStoreChanges(): void {
    this.store.select(ClassroomState).subscribe((classroom: ClassroomStateModel) => {
      this.classroom = classroom;
    });
    this.store.select(LocalUserState).subscribe((localUser: LocalUser) => {
      this.localUser = localUser;
    });
  }

  public listen(): void {
    this.webSocketService.subscribe(
      `/topic/classroom-message/${this.classroom.roomNum}`,
      this.onClassroomMessage.bind(this)
    );

    // PRIVATE TOPICS
    this.webSocketService.subscribe(
      `/topic/classroom-message/${this.classroom.roomNum}/${this.localUser.id}`,
      this.onClassroomMessage.bind(this)
    );
    if (this.localUser.accessType !== AccessType.STUDENT) {
      this.webSocketService.subscribe(
        `/topic/classroom-message/${this.classroom.roomNum}/staff`,
        this.onClassroomMessage.bind(this)
      );
    }

    // SPECIAL TOPICS
    this.webSocketService.subscribe(
      `/topic/classroom-purge/${this.classroom.roomNum}`,
      this.onClassroomPurge.bind(this)
    );
  }

  private onClassroomMessage(message: string): void {
    /* message string should be convertable to ClassroomMessage type */
    this.dataService.handleMessage(JSON.parse(message) as ClassroomMessage);
  }

  private onClassroomPurge(): void {
    this.coreService.onEndLesson();
  }
}
